import api from '../../../App/socket';

export const editGroupMetaData = (_id, params) => (
    api.send({
        api: 'db',
        model: 'User_group',
        action: 'Update',
        options: {
            where: { _id },
            update: params,
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/requests/edit_group_meta_data_request.js